import styled from '@emotion/styled';


export const Wrapper = styled.div`
    padding: 130px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media screen and (min-width: 768px) {
        padding: 170px 0;
    }
`
